import { z } from "zod";

export const TheoryLessonProductTypeEnum = z.enum([
  "Theorieunterricht_Grundstoff",
  "Theorieunterricht_Zusatzstoff_A",
  "Theorieunterricht_Zusatzstoff_B",
  "Theorieunterricht_B96",
  "Theorieunterricht_Zusatzstoff_C",
  "Theorieunterricht_Zusatzstoff_C1",
  "Theorieunterricht_Zusatzstoff_CE",
  "Theorieunterricht_Zusatzstoff_D",
  "Theorieunterricht_Zusatzstoff_D1",
  "Theorieunterricht_Zusatzstoff_L",
  "Theorieunterricht_Zusatzstoff_T",
]);

export type TheoryLessonProductType = z.infer<typeof TheoryLessonProductTypeEnum>;
export type TheoryLessonCategory = TheoryLessonProductType extends `Theorieunterricht_${infer Category}`
  ? Category
  : never;

export function asCategory(productType: TheoryLessonProductType): TheoryLessonCategory {
  return productType.substring("Theorieunterricht_".length) as TheoryLessonCategory;
}

/**
 * A special driving lesson ("besondere Ausbildungsfahrt") is one of the lessons required by law in Germany,
 * see https://www.gesetze-im-internet.de/fahrschausbo_2012/anlage_4.html
 */
export const SpecialDrivingLessonProductTypeEnum = z.enum(["Überlandfahrt", "Autobahnfahrt", "Nachtfahrt"]);

export type SpecialDrivingLessonProductType = z.infer<typeof SpecialDrivingLessonProductTypeEnum>;

export const ProductTypeEnum = z.enum([
  "Übungsstunde",
  ...SpecialDrivingLessonProductTypeEnum.options,
  "Simulator-Fahrstunde",
  "Testfahrt_Schaltkompetenz",
  ...TheoryLessonProductTypeEnum.options,
  "Theorieprüfung",
  "Fahrprüfung",
  "Zoom-Meeting",
  "sonstiges",
]);

export type ProductType = z.infer<typeof ProductTypeEnum>;

export function isTheoryLessonProductType(productType: ProductType): productType is TheoryLessonProductType {
  return TheoryLessonProductTypeEnum.safeParse(productType).success;
}

export function isSpecialDrivingLessonProductType(
  productType: ProductType,
): productType is SpecialDrivingLessonProductType {
  return SpecialDrivingLessonProductTypeEnum.safeParse(productType).success;
}
